
import {defineComponent} from 'vue';
import nieuwsBerichtQuery from '~/graphql/queries/nieuws/nieuwsBericht.gql';
import {Bericht} from '~/graphql/graphql';

export default defineComponent({
  // @ts-expect-error TS2769
  auth: false,

  apollo: {
    nieuwsBericht: {
      query: nieuwsBerichtQuery,
      variables() {
        return {
          slug: this.$route.params.slug,
        };
      },
      result(result) {
        if (!result.data.nieuwsBericht) {
          this.$nuxt.error({
            statusCode: 404,
          });
        }
      },
    },
  },

  data: () => ({
    nieuwsBericht: {} as Bericht,
  }),

  head() {
    if (!this.nieuwsBericht) {
      return {};
    }

    return {
      title: this.nieuwsBericht.title,
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.nieuwsBericht.title,
        },

        {
          hid: 'og:description',
          name: 'og:description',
          content: this.nieuwsBericht.excerpt,
        },

        (this.nieuwsBericht.active_image?.url && this.nieuwsBericht.active_image?.url !== 'not-found.jpg')
          ? {
            hid: 'og:image',
            name: 'og:image',
            content: this.nieuwsBericht.active_image.url,
          }
          : {},
      ],
    };
  },
});
